module.exports = __webpack_public_path__ + "static/media/tree-step-6_2.45fe3e6a.svg";